"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const getFont_1 = __importDefault(require("./utils/getFont"));
const getBorderColor_1 = __importDefault(require("./utils/getBorderColor"));
const getDecoratorBorderRadius_1 = __importDefault(require("./utils/getDecoratorBorderRadius"));
const getDecoratorBackgroundColor_1 = __importDefault(require("./utils/getDecoratorBackgroundColor"));
const getDecoratorBorder_1 = __importDefault(require("./utils/getDecoratorBorder"));
const getDecoratorBorderColor = ({ isRight, theme, ...props }) => {
    if (theme.prefixSuffixInsideInput) {
        return theme.borderColorSemanticBlock;
    }
    if (isRight) {
        return (0, getBorderColor_1.default)({
            theme,
            defaultColor: theme.borderColorSemanticBlock,
            ...props,
        });
    }
    return theme.borderColorSemanticBlock;
};
const InputDecorator = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme, isReadOnly }) => (0, getDecoratorBackgroundColor_1.default)({ theme, isReadOnly })};
  border: ${({ theme, isReadOnly }) => (0, getDecoratorBorder_1.default)({ theme, isReadOnly })};
  border-right-color: ${props => getDecoratorBorderColor({ ...props, isRight: Boolean(props.isPrefix) })};
  border-left-color: ${props => getDecoratorBorderColor({ ...props, isRight: !props.isPrefix })};
  box-sizing: border-box;
  color: ${({ theme }) => theme.colorSemanticBlock};
  display: flex;
  padding: 0 ${({ theme }) => theme.prefixSuffixHorizontalSpacing};
  text-align: left;
  transition: border-color ${({ theme }) => theme.borderTransitionTiming};
  transition-timing-function: ease-in-out;
  width: ${({ theme, autoWidth }) => autoWidth ? 'auto' : theme.widthSemanticBlock};
  border-radius: ${({ theme, isSuffix, isPrefix }) => (0, getDecoratorBorderRadius_1.default)({ theme, isSuffix, isPrefix })};
  & > span {
    ${getFont_1.default}
    ${(0, polished_1.ellipsis)()}
  }
`;
InputDecorator.displayName = 'InputDecorator';
exports.default = InputDecorator;
